import { render, staticRenderFns } from "./IndexInfo.vue?vue&type=template&id=efde500a&scoped=true&"
import script from "./IndexInfo.vue?vue&type=script&lang=js&"
export * from "./IndexInfo.vue?vue&type=script&lang=js&"
import style0 from "./IndexInfo.vue?vue&type=style&index=0&id=efde500a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efde500a",
  null
  
)

export default component.exports